import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import ProgramsPage from "@/pages/ProgramsPage";
import ProgramStablecoinsPage from "@/pages/ProgramStablecoinsPage";
import ProgramAccountingPage from "@/pages/ProgramAccountingPage";
import ProgramPaymentsPage from "@/pages/ProgramPaymentsPage";
import ProgramCompliancePage from "@/pages/ProgramCompliancePage";
import ProgramAuditAssurancePage from "@/pages/ProgramAuditAssurancePage";
import CertificationPathwaysPage from "@/pages/CertificationPathwaysPage";
import ResourcesPage from "@/pages/ResourcesPage";
import ArticleStablecoinsGuidePage from "@/pages/ArticleStablecoinsGuidePage";
import ArticleRecordsGuidePage from "@/pages/ArticleRecordsGuidePage";
import ArticleGlossaryPage from "@/pages/ArticleGlossaryPage";
import ArticleWhyStablecoinsPage from "@/pages/ArticleWhyStablecoinsPage";
import ArticlePaymentsChangingPage from "@/pages/ArticlePaymentsChangingPage";
import ArticleInfrastructurePage from "@/pages/ArticleInfrastructurePage";
import MembershipPage from "@/pages/MembershipPage";
import PartnersPage from "@/pages/PartnersPage";
import PartnerApplyPage from "@/pages/PartnerApplyPage";
import ContactPage from "@/pages/ContactPage";
import ApplyPage from "@/pages/ApplyPage";
import AboutPage from "@/pages/AboutPage";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfUse from "@/pages/legal/TermsOfUse";
import CookiePolicy from "@/pages/legal/CookiePolicy";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route
            path="/programs/digital-money-and-stablecoins"
            element={<ProgramStablecoinsPage />}
          />
          <Route
            path="/programs/digital-asset-accounting"
            element={<ProgramAccountingPage />}
          />
          <Route
            path="/programs/business-payments-and-treasury"
            element={<ProgramPaymentsPage />}
          />
          <Route
            path="/programs/compliance-for-digital-finance-operations"
            element={<ProgramCompliancePage />}
          />
          <Route
            path="/programs/digital-asset-audit-and-assurance"
            element={<ProgramAuditAssurancePage />}
          />
          <Route
            path="/certification-pathways"
            element={<CertificationPathwaysPage />}
          />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route
            path="/resources/understanding-stablecoins-in-business-finance"
            element={<ArticleStablecoinsGuidePage />}
          />
          <Route
            path="/resources/digital-asset-records-and-reporting"
            element={<ArticleRecordsGuidePage />}
          />
          <Route
            path="/resources/glossary-25-essential-digital-finance-terms"
            element={<ArticleGlossaryPage />}
          />
          <Route
            path="/resources/why-finance-teams-are-paying-attention-to-stablecoins"
            element={<ArticleWhyStablecoinsPage />}
          />
          <Route
            path="/resources/how-business-payments-are-changing"
            element={<ArticlePaymentsChangingPage />}
          />
          <Route
            path="/resources/understanding-modern-financial-infrastructure"
            element={<ArticleInfrastructurePage />}
          />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/partners/apply" element={<PartnerApplyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/enrollment-request" element={<ApplyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
